import { spErrorTags } from "@eventr/common";
import { ColoursObj, getContrastYIQ, Icon, MainButton, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useCallback, useEffect, useState } from "react";
import { routes } from "routing";
import { bs } from "state/bound.store";
import { NavigationView } from "../../layout/NavigationView";
import { useRouteQueryParams } from "routing/query-params";

enum OAuthState {
  LOADING,
  ERROR,
  SUCCESS,
}
export const OAuthRedirect = () => {
  const [state, setState] = useState<OAuthState>(OAuthState.LOADING);

  const [minTimeElapsed, setMinTimeElapsed] = useState<boolean>(false);
  const [isResponseReturned, setIsResponseReturned] = useState<boolean>(false);
  const queryParams = useRouteQueryParams();

  const getUser = useCallback(() => {
    const code: string = queryParams.code ?? "";
    const doCodeExchange = async () => {
      try {
        const resp = await bs().exchangeCode(code!);

        if (resp.status === "success") {
          bs().commitTokens(resp.data!);
          await bs().onLogin();
          setIsResponseReturned(true);
          setState(OAuthState.SUCCESS);
        } else {
          setState(OAuthState.ERROR);
          setIsResponseReturned(true);
        }
      } catch (error) {
        spErrorTags("OAuth get user Error ", ["OAuth"], error);
        setState(OAuthState.ERROR);
        setIsResponseReturned(true);
      }
    };
    doCodeExchange();
  }, [setIsResponseReturned, setState, queryParams.code]); // Assuming you have these setters from useState, add them as dependencies

  useEffect(() => {
    getUser();
  }, [getUser]);

  useEffect(() => {
    if (isResponseReturned && minTimeElapsed && state === OAuthState.SUCCESS) {
      window.replacePath(routes.home.path);
    }
  }, [isResponseReturned, minTimeElapsed, state]);

  setTimeout(() => setMinTimeElapsed(true), 1500);

  return state === OAuthState.LOADING || state === OAuthState.SUCCESS ? (
    <div style={{ width: "100%", height: "100%" }}>
      <NavigationView>
        <Stack
          sx={{
            height: "calc(100vh - 103px)",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            padding: "0 16px"
          }}>
          <Icon name="Loading" height="75px" width="75px" />
        </Stack>
      </NavigationView>
    </div>
  ) : (
    <div
      style={{
        position: "absolute",
        height: "100%",
        width: "100%",
        background: "rgba(52, 64, 84, 0.70)",
      }}
    >
      <div
        style={{
          height: "100%",
          filter: "blur(8px)",
        }}
      >
        <NavigationView>
          <div />
        </NavigationView>
      </div>
      <div
        style={{
          position: "absolute",
          height: "200px",
          width: "300px",
          borderRadius: "12px",
          top: "50%",
          left: "50%",
          transform: "translateX(-50%) translateY(-50%)",
          background: ColoursObj.backgrounds.primary,
          padding: "24px 16px",
          gap: "24px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack sx={{
          gap: "8px"
        }}>
          <Typography variant="bodyBold" color={getContrastYIQ(ColoursObj.backgrounds.primary)} sx={{
            textAlign: "center"
          }}>
            {i18n.t("info-dialog.troubleLoggingInTitle")}
          </Typography>
          <Typography color={getContrastYIQ(ColoursObj.backgrounds.primary)} sx={{
            textAlign: "center"
          }}>
            {i18n.t("info-dialog.troubleLoggingInDescription")}
          </Typography>
        </Stack>
        <Stack sx={{
          gap: "8px"
        }}>
          <MainButton
            text={i18n.t("info-dialog.tryAgain")}
            onClick={() => {
              // setIsResponseReturned(false)
              // setMinTimeElapsed(false)
              // getUser()
              // setTimeout(() => setMinTimeElapsed(true), 1500)
              window.replacePath(routes.auth.signIn.path);
            }}
          />
        </Stack>
      </div>
    </div>
  );
};
